// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalImageView_main__pVhxc {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    z-index: 1030;
    background-color: rgba(0, 0, 0, 0.6);
}

.ModalImageView_container__MhoG2 {
    position: relative;
    width: 90vw;
    height: 90vh;
    margin: auto;
    transform: translateY(5vh);
}

.ModalImageView_img_limit__VWi5i,
.ModalImageView_video_limit__qPqSl {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    vertical-align: middle;
    max-width: 100%;
    max-height: 100%;
}

.ModalImageView_video_limit__qPqSl {
    width: 100%;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ModalImageView/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".main {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n    z-index: 1030;\n    background-color: rgba(0, 0, 0, 0.6);\n}\n\n.container {\n    position: relative;\n    width: 90vw;\n    height: 90vh;\n    margin: auto;\n    transform: translateY(5vh);\n}\n\n.img_limit,\n.video_limit {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    vertical-align: middle;\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.video_limit {\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ModalImageView_main__pVhxc`,
	"container": `ModalImageView_container__MhoG2`,
	"img_limit": `ModalImageView_img_limit__VWi5i`,
	"video_limit": `ModalImageView_video_limit__qPqSl`
};
export default ___CSS_LOADER_EXPORT___;
